import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { CodeIdChipComponent } from '../code-id-chip/code-id-chip.component';
import { copyText } from '../../shared/clipboard';

const COPIED_FEEDBACK_MS = 1400;

/**
 * Nummer eines gespeicherten Testschritts (z. B. `TS-035`) als Pille im Stil der
 * Bibliotheks-ID; ein Klick kopiert sie (NEX-1296). Die Nummer braucht man beim Import
 * automatisierter Ergebnisse, die über TS-### im Robot-Keyword zugeordnet werden.
 */
@Component({
  selector: 'app-step-key-pill',
  imports: [TranslatePipe, MatIcon, CodeIdChipComponent],
  templateUrl: './step-key-pill.component.html',
  styleUrl: './step-key-pill.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepKeyPillComponent {
  readonly key = input.required<string>();

  readonly copied = signal(false);
  private resetHandle: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    inject(DestroyRef).onDestroy(() => this.clearReset());
  }

  onClick(event: Event): void {
    // Die Pille sitzt auch im Modul-Kopf, der per Klick auf- und zuklappt.
    event.stopPropagation();
    void copyText(this.key()).then((copied) => {
      if (copied) {
        this.flagCopied();
      }
    });
  }

  onKeydown(event: KeyboardEvent): void {
    // Der Modul-Kopf klappt auf Enter/Leertaste und verhindert dabei den Klick des Buttons.
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
    }
  }

  private flagCopied(): void {
    this.copied.set(true);
    this.clearReset();
    this.resetHandle = setTimeout(() => this.copied.set(false), COPIED_FEEDBACK_MS);
  }

  private clearReset(): void {
    if (this.resetHandle !== null) {
      clearTimeout(this.resetHandle);
      this.resetHandle = null;
    }
  }
}
